module.exports = __webpack_public_path__ + "static/media/SDG-technology.55bf306c.jpg";